/**
 * **core の表示形式（POS_*）の読み方**（Issue #766）。台本を作る層（`boardTimeline.js`）と描く層の入口（`duelBoard.js`）の両方が読むので、
 * どちらにも属さないここに置く（描く層が盤面の進み＝台本の実装を import しないため。`stageScript.boundary.test.js`）。
 *
 * pos は core の POS_*（1 表攻撃 / 2 裏攻撃 / 4 表守備 / 8 裏守備）。場のカードだけ意味がある。
 */
export const POS = Object.freeze({ FACEUP_ATTACK: 1, FACEDOWN_ATTACK: 2, FACEUP_DEFENSE: 4, FACEDOWN_DEFENSE: 8 });
export const isFaceUp = (pos) => (pos & (POS.FACEUP_ATTACK | POS.FACEUP_DEFENSE)) !== 0;
export const isDefense = (pos) => (pos & (POS.FACEUP_DEFENSE | POS.FACEDOWN_DEFENSE)) !== 0;
